export default "__VITE_ASSET__Dq$vmLyK__"